// extracted by mini-css-extract-plugin
module.exports = {"container":"LegalDisclaimerBannerIndia_container__tDHEm","inner":"LegalDisclaimerBannerIndia_inner__I6k_e","text":"LegalDisclaimerBannerIndia_text__Kx3cf"};